export const GET_COURSES_TEMPLATES_REQUEST = 'COURSES_TEMPLATES.GET_COURSES_TEMPLATES_REQUEST';
export const GET_COURSES_TEMPLATES_SUCCESS = 'COURSES_TEMPLATES.GET_COURSES_TEMPLATES_SUCCESS';
export const GET_COURSES_TEMPLATES_ERROR = 'COURSES_TEMPLATES.GET_COURSES_TEMPLATES_ERROR';
